import { cn } from "@workspace/ui/lib/utils";
import Image from "next/image";

export default function DoctorTestimonial({
  title,
  image,
  designation,
  name,
  layoutClass
}: {
  title: string;
  image: string;
  designation: string;
  name: string;
  layoutClass?: string;
}) {
  return (
    <div className={cn("rounded-[10px] pb-3",layoutClass)}>
      <div className="p-5 bg-[#F3F4ED] flex flex-col gap-3 rounded-tl-[10px] rounded-tr-[10px]">
        <h3 className="title-16 text-primary">
          “{title}”
        </h3>
        <div className="flex items-center gap-3">
          <Image
            src={image}
            alt={name}
            width={48}
            height={48}
            className="rounded-full"
          />
          <div className="flex flex-col gap-0.5">
            <p className="title-14 text-primary">
              {name}
            </p>
            <p className="title-14 text-[#6E7F84]">
              {designation}
            </p>
          </div>
        </div>
      </div>
      <div className="py-4 px-5 flex gap-1 bg-[#EAECDF] rounded-bl-[10px] rounded-br-[10px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="17"
          viewBox="0 0 90 17"
          fill="none"
        >
          <path
            d="M7.60847 0L9.31678 5.77312H14.845L10.3726 9.3411L12.0809 15.1142L7.60847 11.5462L3.13603 15.1142L4.84435 9.3411L0.371921 5.77312H5.90015L7.60847 0Z"
            fill="black"
          />
          <path
            d="M26.3038 0L28.0121 5.77312H33.5403L29.0679 9.3411L30.7762 15.1142L26.3038 11.5462L21.8313 15.1142L23.5397 9.3411L19.0672 5.77312H24.5955L26.3038 0Z"
            fill="black"
          />
          <path
            d="M44.9996 0L46.7079 5.77312H52.2361L47.7637 9.3411L49.472 15.1142L44.9996 11.5462L40.5271 15.1142L42.2355 9.3411L37.763 5.77312H43.2913L44.9996 0Z"
            fill="black"
          />
          <path
            d="M63.6949 0L65.4032 5.77312H70.9314L66.459 9.3411L68.1673 15.1142L63.6949 11.5462L59.2225 15.1142L60.9308 9.3411L56.4583 5.77312H61.9866L63.6949 0Z"
            fill="black"
          />
          <path
            d="M82.3912 0L84.0995 5.77312H89.6277L85.1553 9.3411L86.8636 15.1142L82.3912 11.5462L77.9187 15.1142L79.6271 9.3411L75.1546 5.77312H80.6829L82.3912 0Z"
            fill="#D2D4C3"
          />
          <mask
            id="mask0_21018_19817"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="75"
            y="0"
            width="15"
            height="16"
          >
            <path
              d="M82.3912 0L84.0995 5.77312H89.6277L85.1553 9.3411L86.8636 15.1142L82.3912 11.5462L77.9187 15.1142L79.6271 9.3411L75.1546 5.77312H80.6829L82.3912 0Z"
              fill="black"
            />
          </mask>
          <g mask="url(#mask0_21018_19817)">
            <rect x="73" y="-3" width="9" height="21" fill="black" />
          </g>
        </svg>
        <p className="captitle-10 text-primary">
          TRUSTED BY 100,000+ COUPLES
        </p>
      </div>
    </div>
  );
}
